import { render } from "./WarrantyRepairButton.vue?vue&type=template&id=38d59528"
import script from "./WarrantyRepairButton.vue?vue&type=script&lang=js"
export * from "./WarrantyRepairButton.vue?vue&type=script&lang=js"

import "./WarrantyRepairButton.vue?vue&type=style&index=0&id=38d59528&lang=css"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__